import { Image } from "react-bootstrap";
import styled from "styled-components";

export const StyledProductBadge = styled(Image)`
    top: 10px;
    height: 40px;
    position: absolute;
    left: 15px;
`;
